import i18n from '@/plugins/i18n';
import { LOCALE_HEADER, LOCALE_QUERY_PARAM } from '@/constants/locale-constants';

/**
 * Idioma da tela em todo pedido: o backend põe esse idioma no link externo que gerar
 * (ficha, documentos, aprovação), para o cliente abrir no idioma de quem gerou.
 */
export function withLocaleHeader(config) {
  config.headers = config.headers || {};
  config.headers[LOCALE_HEADER] = i18n.locale;

  return config;
}

/** Link externo montado no front (selfie, cadastro do corban): leva o idioma da tela em ?lang=. */
export function withLocaleQuery(url) {
  if (!url) return url;

  return `${url}${url.includes('?') ? '&' : '?'}${LOCALE_QUERY_PARAM}=${encodeURIComponent(i18n.locale)}`;
}
